import { useCallback, useEffect, useState } from 'react';

const SIDEBAR_STORAGE_KEY = 'sidebar-open';

export function useSidebarState() {
  const [isOpen, setIsOpen] = useState(() => {
    const stored = localStorage.getItem(SIDEBAR_STORAGE_KEY);
    return stored ? stored === 'true' : true;
  });

  const toggleSidebar = useCallback(() => {
    setIsOpen((prev) => {
      const newValue = !prev;
      localStorage.setItem(SIDEBAR_STORAGE_KEY, newValue.toString());
      return newValue;
    });
  }, []);

  const setSidebarOpen = useCallback((open: boolean) => {
    setIsOpen(open);
    localStorage.setItem(SIDEBAR_STORAGE_KEY, open.toString());
  }, []);

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === SIDEBAR_STORAGE_KEY && e.newValue !== null) {
        setIsOpen(e.newValue === 'true');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return {
    isOpen,
    toggleSidebar,
    setSidebarOpen,
  };
}
